import AbstractRepository from "@/repositories/AbstractRepository";

export default class UserRepository extends AbstractRepository {
    protected static resource: string = "user";

    protected static defaultFields: string[] = [
        "uuid",
        "displayName",
        "username",
        "subpole.name",
        "department.name",
        "roles",
        "active",
        "userHideFeatures.code",
        "profile",
        "applicationPermissions.name",
        "isBiSync",
        "socleApprover",
    ];
}
